// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteProductsStyles } from "@steiner/Overrides/Widgets/Header/AutocompleteProducts";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.headerText = {
    variant: "h6",
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
            margin-bottom: 0;
        }
    `,
};

autocompleteProductsStyles.container = {
    gap: 0,
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

autocompleteProductsStyles.productsContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 8px;
        column-gap: 12px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(1, 1fr);
        }
    `,
};

autocompleteProductsStyles.productContainer = {
    css: css`
        display: flex;
        align-items: flex-start;
        column-gap: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            max-width: 100%;
            &:last-child {
                padding-bottom: 0;
                border-bottom: none;
            }
        }
    `,
};

autocompleteProductsStyles.image = {
    width: "52px",
    height: "52px",
    css: css`
        min-width: 52px;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

autocompleteProductsStyles.titleLink = {
    typographyProps: {
        size: 12,
        css: css`
            line-height: 14px;
            ${ellipsis(3)}
        `,
    },
};
